import { PORTAL_UI_V2 } from "../config/uiTheme";
import SiteInfoLegacy from "./site/SiteInfoLegacy";
import SiteInfoV2 from "./site/SiteInfoV2";

const SiteInfo = () => (PORTAL_UI_V2 ? <SiteInfoV2 /> : <SiteInfoLegacy />);

export default SiteInfo;
